import { Component, Input, OnChanges } from '@angular/core';

import { Landscape } from 'app/modules/browse/models/landscape';
import { WorldRegion } from 'app/modules/browse/models/world-region';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-simple-card',
  templateUrl: './simple-card.component.html',
  styleUrls: ['./simple-card.component.scss'],
  standalone: true,
  imports: [NgClass, TranslateModule, RouterLink],
})
export class SimpleCardComponent implements OnChanges {
  @Input() item: Landscape | WorldRegion;
  @Input() isRegion: boolean;
  translationPath: string;

  constructor() {
    this.isRegion = false;
    this.translationPath = '';
  }

  ngOnChanges() {
    const key: string = this.isRegion ? 'regions' : 'landscapes';
    this.translationPath = `browse.landscapesAndRegions.${key}.${this.item.name}`;
  }
}
